import { FireCMSAppConfig } from "@firecms/core";

// Import all schemas
import AssetSchema from "./schemas/asset";
import CourseSchema from "./schemas/course";
import LinkSchema from "./schemas/link";
import ImageSchema from "./schemas/image";
import Iconchema from "./schemas/icons";
import CategorySchema from "./schemas/category";
import PartnerSchema from "./schemas/partner";
import TeamSchema from "./schemas/team";
import BlogSchema from "./schemas/blog";
import CustomOfferSchema from "./schemas/customOffer";
import ReviewSchema from "./schemas/review";

const appConfig: FireCMSAppConfig = {
  version: "1",
  collections: async () => {
    return [
      AssetSchema,
      CourseSchema,
      LinkSchema,
      ImageSchema,
      Iconchema,
      CategorySchema,
      PartnerSchema,
      TeamSchema,
      BlogSchema,
      CustomOfferSchema,
      ReviewSchema,
    ];
  },
};

export default appConfig;

